// i18n area 'auth' — locale lt-LT (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.lt-LT.meta.json.
import type { enUS } from './auth'

export const ltLT: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Prisijunkite prie savo paskyros',
    username: 'Naudotojo vardas',
    usernamePlaceholder: 'Įveskite naudotojo vardą',
    usernameHint: 'Naudokite naudotojas@domenas, kad prisijungtumėte per katalogų realm',
    continue: 'Tęsti',
    changeUser: 'Tai ne jūs?',
    password: 'Slaptažodis',
    forgotPassword: 'Pamiršote slaptažodį?',
    submit: 'Prisijungti',
    otp: 'Vienkartinis kodas',
    otpSubtitle: 'Įveskite kodą iš savo autentikatoriaus',
    otpHint: 'Šeši skaitmenys iš tapatumo nustatymo programėlės arba vienas iš atkūrimo kodų',
    otpSubmit: 'Patikrinti',
    invalidCredentials: 'Neteisingas naudotojo vardas arba slaptažodis',
    tooManyAttempts: 'Per daug bandymų — palaukite akimirką ir bandykite dar kartą',
    realmUnavailable: 'Realm šiuo metu negali patikrinti prisijungimo duomenų — klasterio store nepasiekiamas. Prisijunkite kaip vietinis naudotojas (break-glass).',
    genericError: 'Prisijungti nepavyko — ar TVirt backend pasiekiamas?'
  },
  user: {
    logout: 'Atsijungti',
    password: {
      menu: 'Keisti slaptažodį',
      title: 'Pakeiskite savo slaptažodį',
      current: 'Dabartinis slaptažodis',
      new: 'Naujas slaptažodis',
      confirm: 'Pakartokite naują slaptažodį',
      mismatch: 'Slaptažodžiai nesutampa',
      error: 'Nepavyko pakeisti slaptažodžio',
      forcedTitle: 'Pakeiskite slaptažodį, kad galėtumėte tęsti',
      forcedHint: 'Šį slaptažodį nustatė administratorius, todėl prieš įeinant jį būtina pakeisti.',
      forcedSubmit: 'Pakeisti ir įeiti'
    },
    mfa: {
      title: 'Dviejų veiksnių tapatumo nustatymas',
      subtitle: 'Antras veiksnys, reikalaujamas kiekvieną kartą prisijungiant',
      loadError: 'Nepavyko įkelti antro veiksnio būsenos',
      enrolled: 'Aktyvus',
      notEnrolled: 'Neaktyvus',
      enrolledAt: 'Aktyvuota',
      codesRemaining: 'Likę atkūrimo kodai',
      requiredHint:
        'Administratorius reikalauja antro veiksnio šioje paskyroje: sukonfigūruokite jį dabar — kol to nepadarysite, prisijungti galėsite, bet daugiau beveik nieko.',
      enroll: 'Konfigūruoti',
      enrollTitle: 'Konfigūruoti dviejų veiksnių tapatumo nustatymą',
      enrollHint: 'Nuskaitykite šį kodą tapatumo nustatymo programėle, tada įveskite jos rodomą kodą patvirtinimui.',
      secretHint: 'Nepavyksta nuskaityti? Įveskite šį slaptą raktą programėlėje:',
      code: 'Kodas iš programėlės',
      confirm: 'Patvirtinti',
      startError: 'Nepavyko pradėti konfigūravimo',
      confirmError: 'Nepavyko patvirtinti konfigūravimo',
      codesTitle: 'Jūsų atkūrimo kodai',
      codesWarning:
        'Šie kodai parodomi tik vieną kartą. Išsaugokite juos dabar: kiekvienas leidžia prisijungti, kai autentikatorius nepasiekiamas, ir galioja tik vieną kartą.',
      codesAck: 'Atkūrimo kodus išsaugojau',
      codesDone: 'Atlikta',
      copy: 'Kopijuoti',
      copied: 'Nukopijuota',
      download: 'Atsisiųsti',
      regenerate: 'Nauji atkūrimo kodai',
      regenerateTitle: 'Sugeneruoti atkūrimo kodus iš naujo',
      regenerateHint: 'Visi iki šiol išduoti kodai nustoja veikti tą akimirką, kai sugeneruojamas naujas rinkinys.',
      regenerateConfirm: 'Generuoti iš naujo',
      regenerateError: 'Nepavyko iš naujo sugeneruoti atkūrimo kodų',
      remove: 'Šalinti',
      removeTitle: 'Pašalinti antrą veiksnį',
      removeConfirm: 'Šalinti',
      removeHint: 'Paskyra grįžta prie vien slaptažodžio. Antrą veiksnį galite sukonfigūruoti iš naujo bet kada.',
      removeRequiredHint:
        'Administratorius reikalauja antro veiksnio šioje paskyroje, todėl serveris pašalinimą atmes — pirma paprašykite panaikinti šį reikalavimą.',
      removeError: 'Nepavyko pašalinti antro veiksnio'
    },
    profile: {
      menu: 'Eiti į mano profilį',
      sessions: 'Aktyvūs seansai',
      sessionsHint: 'Jūsų atviri seansai šiame mazge',
      sessionsEmpty: 'Aktyvių seansų nėra',
      sessionCreated: 'Prisijungta',
      sessionExpires: 'Baigiasi',
      revoke: 'Panaikinti seansą',
      revokeError: 'Nepavyko panaikinti seanso',
      loadError: 'Nepavyko įkelti seansų'
    }
  }
}
